// Please sync with packages/frontend/feature-flags/src/FeatureFlagModal.tsx
export enum FeatureFlag {
  /** Permanent (for now) */
  CoinList = 'CoinList' /** Only exists for Drescher */,
  DevTools = 'DevTools',

  /** Feature flag to be enabled to HIDE the feature (inverted semantics) */
  HideCashManagementDeposit = 'HideCashManagementDeposit',
  HideCashManagementTransfer = 'HideCashManagementTransfer',
  HidePliantReferenceInLinkSelector = 'HidePliantReferenceInLinkSelector',
  HidePliantReferenceInOverview = 'HidePliantReferenceInOverview',
  AccountingPaymentsNew = 'AccountingPaymentsNew' /** Keep for Caritas until autumn */,
  dev_ServiceProviderApp = 'dev_ServiceProviderApp' /** Keep for Caritas until autumn */,

  /** Development */
  dev_CaritasManualRoles = 'dev_CaritasManualRoles',

  /** Feature to be removed (Keep for Drescher) */
  AccountingPayments = 'AccountingPayments',

  dev_ResidentTypeAndWalletModeSelectors = 'dev_ResidentTypeAndWalletModeSelectors',
  dev_InitialBalanceForResident = 'dev_InitialBalanceForResident',
  dev_NationalityAndCountryOfResidenceSelectors = 'dev_NationalityAndCountryOfResidenceSelectors',

  dev_OfflineSepaMandate = 'dev_OfflineSepaMandate',
  dev_OfflineSepaManualPayin = 'dev_OfflineSepaManualPayin',
  dev_UnassignPliantTransaction = 'dev_UnassignPliantTransaction',

  /** Expense management */
  ExpenseManagement = 'ExpenseManagement',
  ReceiptManagement = 'ReceiptManagement',
  ReceiptImageAnalysis = 'ReceiptImageAnalysis',
  ReceiptDocumentScanner = 'ReceiptDocumentScanner',

  /** Caritas Hauptkasse-prompt on Adjustment cash transaction groups */
  MainCashboxAdjustmentFlag = 'MainCashboxAdjustmentFlag',

  /**
   * Scope selector tabs. Tenant level only — an NH-level override would make
   * the tabs appear and disappear as the user switches homes.
   */
  dev_LegalEntityScope = 'dev_LegalEntityScope',
  dev_TenantScope = 'dev_TenantScope',

  /** "Mismatch risk" tab in the cash transaction group list */
  MismatchRiskTab = 'MismatchRiskTab',
}

export enum FeatureFlagStatus {
  Disabled,
  Enabled,
}
